const BASE_NAME = '@@DEEI/GLOBAL/COMMON';

export const DEVICE_RESIZE = `${BASE_NAME}/DEVICE_RESIZE`;
export const PAGE_TRANSITION = `${BASE_NAME}/PAGE_TRANSITION`;
